import { render, staticRenderFns } from "./tsInterest.vue?vue&type=template&id=3b268757&scoped=true"
import script from "./tsInterest.vue?vue&type=script&lang=js"
export * from "./tsInterest.vue?vue&type=script&lang=js"
import style0 from "./tsInterest.vue?vue&type=style&index=0&id=3b268757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b268757",
  null
  
)

export default component.exports